import {
  CREATE_FILE_REFERENCE_REQUEST,
  createFileReferenceSuccess,
  createFileReferenceFailure,
  showSuccessNotification
}                               from 'Redux/Action';
import { ofType }               from 'redux-observable';
import { from }                 from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';
import { TEpic }                from 'Redux/Config';

export const createFileReferenceEpic: TEpic = (action$, store$, { FileReferenceRepository }) => {
  return action$.pipe(
    ofType(CREATE_FILE_REFERENCE_REQUEST),
    mergeMap((action: any) => {
      return from(FileReferenceRepository.create(action.payload.fileResourceData)).pipe(
        mergeMap((fileReference) => {
          return from([
            showSuccessNotification(`FileReference wurde erfolgreich erstellt`),
            createFileReferenceSuccess(fileReference),
          ]);
        }),
        catchError(error => {
          return from([
            createFileReferenceFailure(error),
          ]);
        })
      )
    })
  );
};
